module.exports = __webpack_public_path__ + "media/styles/images/svg/check-gray-light-56143622d037efb3bf2bc689d1f14fd1.svg";